module.exports = __webpack_public_path__ + "static/media/config.afe16287.svg";